module.exports = __webpack_public_path__ + "img/processing.f44c6358.png";